"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createOrder;
function createOrder() {
    var fixture = init();

    function init() {
        return {};
    }

    return {
        setRestaurantId: function setRestaurantId(id) {
            fixture.restaurantId = id;
            return this;
        },
        setLocale: function setLocale(locale) {
            fixture.locale = locale;
            return this;
        },
        setCurrency: function setCurrency(currency) {
            fixture.currency = currency;
            return this;
        },
        setContact: function setContact(contact) {
            fixture.contact = contact;
            return this;
        },
        setPrice: function setPrice(price) {
            fixture.price = price;
            return this;
        },
        setReceived: function setReceived(received) {
            fixture.received = received;
            return this;
        },
        setOrderItems: function setOrderItems(orderItems) {
            fixture.orderItems = orderItems;
            return this;
        },
        setOrderCharges: function setOrderCharges(orderCharges) {
            fixture.orderCharges = orderCharges;
            return this;
        },
        addCharge: function addCharge(chargeV2) {
            fixture.chargesV2 = fixture.chargesV2 || [];
            fixture.chargesV2.push(chargeV2);
            return this;
        },
        setDispatch: function setDispatch(dispatch) {
            fixture.delivery = dispatch;
            return this;
        },
        setPreorder: function setPreorder(submitAt) {
            fixture.submitAt = submitAt;
            return this;
        },
        setSubmitted: function setSubmitted(submitted) {
            fixture.submitted = submitted;
            return this;
        },
        setCreated: function setCreated(timestamp) {
            fixture.created = timestamp;
            return this;
        },
        addPayment: function addPayment(payment) {
            fixture.payments = fixture.payments || [];
            fixture.payments.push(payment);
            return this;
        },
        setComment: function setComment(comment) {
            fixture.comment = comment;
            return this;
        },
        setDeveloperId: function setDeveloperId(developerId) {
            fixture.developerId = developerId;
            return this;
        },
        setPlatform: function setPlatform(platform) {
            fixture.platform = platform;
            return this;
        },
        setSource: function setSource(source) {
            fixture.source = source;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/Order.js
// module id = 910
// module chunks = 0